import TeacherRankingAPI from '@/apis/business/teacher/teacher-ranking-api.js'

export default {
  namespaced: true,
  state: {
    listRankingGiftCard: {}, // ranking và giftCard của giáo viên,
    isShowRecommendShareExercise: false // Gợi ý giáo viên chia sẻ thêm học liệu để tăng rank
  },
  getters: {},
  mutations: {
    /**
     * @description Set giá trị cho isShowRecommendShareExercise = true
     * @author VHSON
     */
    setIsShowRecommendShareExercise (state) {
      state.isShowRecommendShareExercise = true
    },

    /**
     * @description Set giá trị cho isShowRecommendShareExercise = false
     * @author VHSON
     */
    setIsNotShowRecommendShareExercise (state) {
      state.isShowRecommendShareExercise = false
    }
  },
  actions: {

    /**
     * update teacher ranking sau khi nhận quà
     * @param {*} context
     * @param {*} params
     * @returns
     */
    updateTeacherRanking (context, params) {
      return new Promise((resolve, reject) => {
        TeacherRankingAPI.putAsync(`${params.Id}`, params)
          .then((res) => {
            resolve(res.IsSuccess)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
